import useRole from 'src/features/auth/hooks/useUserRoles';
import useUsers from 'src/features/users/hooks/useUsers';
import { Feature, FeatureState } from 'src/ts/enums';
import { IPropertyFeature } from 'src/ts/interfaces';

// Hides the generic property links for Building Manager, Leasing Agent and
// On-site Representative when the disable_property_links property feature is
// on. Deliberately narrower than isLeasingTeam: Company Admin and Owner keep
// their links. ITL-3070.
const useHidePortalLinks = () => {
  const { userResponse } = useUsers();
  const { isLeasingAgentOrOnSiteRepresentative } = useRole();

  const isLinkHiddenRole = Boolean(isLeasingAgentOrOnSiteRepresentative);

  const hidePropertyLinks = (propertyFeatures?: IPropertyFeature[]) =>
    isLinkHiddenRole &&
    Boolean(
      propertyFeatures?.some(
        (feature) =>
          feature.code === Feature.DISABLE_PROPERTY_LINKS && feature.state === FeatureState.ENABLED
      )
    );

  const hideDocumentLinksTab =
    isLinkHiddenRole &&
    Boolean(
      userResponse?.features_enabled_in_all_user_properties?.includes(
        Feature.DISABLE_PROPERTY_LINKS
      )
    );

  return {
    hidePropertyLinks,
    hideDocumentLinksTab
  };
};

export default useHidePortalLinks;
